import { APP_ENVIRONMENT_BADGE } from '@/shared/constants/app-environment'
import { cn } from '@/shared/lib/utils'

const OrganizationHeader = () => {
  return (
    <div className="flex">
      <div className="relative p-1 dark:bg-white rounded-md shrink-0 group-data-[collapsible=icon]:w-full">
        <img src="/images/logo.svg" className="w-[34px] h-auto" alt="logo" />
        {APP_ENVIRONMENT_BADGE ? (
          <span
            className={cn(
              'absolute -bottom-0.5 -right-1.5 text-white text-[7px] font-bold leading-none px-1 py-0.5 rounded-sm shadow-sm z-10',
              APP_ENVIRONMENT_BADGE.className
            )}
          >
            {APP_ENVIRONMENT_BADGE.label}
          </span>
        ) : null}
      </div>
      <div className="flex flex-col justify-center overflow-hidden whitespace-nowrap group-data-[collapsible=icon]:hidden pl-2">
        <span className="text-primary dark:text-white font-bold text-sm">IDC Forms</span>
        <span className="dark:text-muted-foreground text-xs">Real Estate</span>
      </div>
    </div>
  )
}

export default OrganizationHeader
